@if (exported) {
  <div class="exported">Exported</div>
}

<div
  class="tile-container"
  [ngClass]="{ selected: libItem.selected, disabled }"
  (click)="handleClick()"
>
  @if (libItem.payload.mediaType === "Photo") {
    <div class="media-container">
      <img
        [src]="
          '/api/v2/media/' + libItem.payload.id + '?size=Medium'
            | clink
            | secure
        "
        (load)="loaded = true"
        class="appear-long"
        [ngClass]="{ 'appear-now': loaded }"
      />
      @if (!loaded) {
        <div class="loading">
          <mat-icon>photo</mat-icon>
        </div>
      }
    </div>
  }
  @if (libItem.payload.mediaType === "Video") {
    <div class="media-container">
      <img
        [src]="
          '/api/v2/media/' + libItem.payload.id + '?size=Medium'
            | clink
            | secure
        "
      />
    </div>
  }
  @if (libItem.payload && libItem.payload.creator) {
    <div class="name-panel">
      @if (
        libItem.payload &&
        libItem.payload.patientData &&
        libItem.payload.patientData.uid
      ) {
        <div class="patient-id">
          {{ libItem.payload.patientData.uid }}
        </div>
      }
      @if (libItem.payload && libItem.payload.mediaType === "Video") {
        <div class="video-icon">
          <mat-icon [svgIcon]="'icon-video'"></mat-icon>
        </div>
      }
      <div class="name-box">
        <div class="font-grey font-12 by">by</div>
        <div class="name-field">
          @if (!ownFile) {
            <div class="celo-elipsis fw">
              {{ libItem.payload.creator.title }}
              {{ libItem.payload.creator.firstName }}
              {{ libItem.payload.creator.lastName }}
            </div>
          }
          @if (ownFile) {
            <div>You</div>
          }
        </div>
        @if (canSelect) {
          <mat-icon>{{
            libItem.selected ? "check_circle" : "radio_button_unchecked"
          }}</mat-icon>
        }
      </div>
    </div>
  }
</div>
